export const DAYS_IN_WEEK = 7 as const
export const TODAY = new Date()
